import { render, staticRenderFns } from "./OrderAddress.vue?vue&type=template&id=3c437c80&scoped=true&"
import script from "./OrderAddress.vue?vue&type=script&lang=js&"
export * from "./OrderAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c437c80",
  null
  
)

export default component.exports